import React, { FC } from "react"

interface HeaderProps {
  title?: string
  breadcrumb?: string
  onSearch?: (value: string) => void
  onCreateNew?: () => void
  showSearch?: boolean
}

const Header: FC<HeaderProps> = ({ 
  title = "予約申請一覧",
  breadcrumb = "ホーム / 予約管理 / 一覧",
  onSearch, 
  onCreateNew,
  showSearch = false
}) => {
  return (
    <header className="bg-white border-b border-gray-200 h-16 flex items-center justify-between px-8 sticky top-0 z-10 shadow-sm">
      <div className="flex items-center gap-4">
        <h1 className="text-2xl font-bold text-gray-900 m-0">{title}</h1>
        <div className="text-sm text-gray-500">{breadcrumb}</div>
      </div>
      
      <div className="flex items-center gap-4">
        {showSearch && (
          <div className="relative">
            <svg
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <input
              type="text"
              placeholder="予約IDや契約者名で検索..."
              className="pl-10 pr-4 py-2 border border-gray-200 rounded-lg bg-gray-50 text-sm w-[300px] transition-all focus:outline-none focus:border-primary focus:ring-3 focus:ring-primary/10"
              onChange={(e) => onSearch?.(e.target.value)}
            />
          </div>
        )}
        
        <div className="flex items-center gap-2">
          {/* <button
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-primary text-white rounded-lg text-sm font-medium transition-all hover:bg-primary-dark hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus:ring-3 focus:ring-primary/10 min-h-[2.5rem]"
            onClick={onCreateNew}
          >
            <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            新規予約
          </button> */}
        </div>
      </div>
    </header>
  )
}

export default Header

